// @flow
import React from 'react';

type Props = {
  errorMessage?: string,
  errorNoteId?: string,
  isErrored: boolean,
};

export const ErrorNote = ({
  errorMessage,
  errorNoteId = 'error-note',
  isErrored = false,
}: Props) => (
  <div id={errorNoteId} aria-live="assertive" className="text-sm text-red">
    {isErrored && errorMessage && <p className="pt-1 pb-2 m-0">{errorMessage}</p>}
  </div>
);
